module.exports = __webpack_public_path__ + "static/media/dungeon_wall_cracked.02b73cf9.png";